/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicLayoutImport } from './routes/_public/_layout'
import { Route as PrivateLayoutImport } from './routes/_private/_layout'
import { Route as PublicLayoutIndexImport } from './routes/_public/_layout/index'
import { Route as PublicLayoutTokensImport } from './routes/_public/_layout/tokens'
import { Route as PublicLayoutReferralsImport } from './routes/_public/_layout/referrals'
import { Route as PublicLayoutLoginImport } from './routes/_public/_layout/login'
import { Route as PrivateLayoutSignInImport } from './routes/_private/_layout/sign-in'
import { Route as PublicLayoutUsersIndexImport } from './routes/_public/_layout/users.index'
import { Route as PublicLayoutTransactionsIndexImport } from './routes/_public/_layout/transactions.index'
import { Route as PublicLayoutRebalanceIndexImport } from './routes/_public/_layout/rebalance.index'
import { Route as PublicLayoutPoolsIndexImport } from './routes/_public/_layout/pools.index'
import { Route as PublicLayoutUsersUserImport } from './routes/_public/_layout/users/$user'
import { Route as PublicLayoutTransactionsTransactionImport } from './routes/_public/_layout/transactions/$transaction'
import { Route as PublicLayoutTokensTokenImport } from './routes/_public/_layout/tokens/$token'
import { Route as PublicLayoutRebalanceRebalanceImport } from './routes/_public/_layout/rebalance/$rebalance'
import { Route as PublicLayoutPoolsPoolImport } from './routes/_public/_layout/pools/$pool'

// Create/Update Routes

const PublicLayoutRoute = PublicLayoutImport.update({
  id: '/_public/_layout',
  getParentRoute: () => rootRoute,
} as any)

const PrivateLayoutRoute = PrivateLayoutImport.update({
  id: '/_private/_layout',
  getParentRoute: () => rootRoute,
} as any)

const PublicLayoutIndexRoute = PublicLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicLayoutRoute,
} as any)

const PublicLayoutTokensRoute = PublicLayoutTokensImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => PublicLayoutRoute,
} as any)

const PublicLayoutReferralsRoute = PublicLayoutReferralsImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => PublicLayoutRoute,
} as any)

const PublicLayoutLoginRoute = PublicLayoutLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicLayoutRoute,
} as any)

const PrivateLayoutSignInRoute = PrivateLayoutSignInImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PrivateLayoutRoute,
} as any)

const PublicLayoutUsersIndexRoute = PublicLayoutUsersIndexImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => PublicLayoutRoute,
} as any)

const PublicLayoutTransactionsIndexRoute =
  PublicLayoutTransactionsIndexImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => PublicLayoutRoute,
  } as any)

const PublicLayoutRebalanceIndexRoute = PublicLayoutRebalanceIndexImport.update(
  {
    id: '/rebalance/',
    path: '/rebalance/',
    getParentRoute: () => PublicLayoutRoute,
  } as any,
)

const PublicLayoutPoolsIndexRoute = PublicLayoutPoolsIndexImport.update({
  id: '/pools/',
  path: '/pools/',
  getParentRoute: () => PublicLayoutRoute,
} as any)

const PublicLayoutUsersUserRoute = PublicLayoutUsersUserImport.update({
  id: '/users/$user',
  path: '/users/$user',
  getParentRoute: () => PublicLayoutRoute,
} as any)

const PublicLayoutTransactionsTransactionRoute =
  PublicLayoutTransactionsTransactionImport.update({
    id: '/transactions/$transaction',
    path: '/transactions/$transaction',
    getParentRoute: () => PublicLayoutRoute,
  } as any)

const PublicLayoutTokensTokenRoute = PublicLayoutTokensTokenImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => PublicLayoutTokensRoute,
} as any)

const PublicLayoutRebalanceRebalanceRoute =
  PublicLayoutRebalanceRebalanceImport.update({
    id: '/rebalance/$rebalance',
    path: '/rebalance/$rebalance',
    getParentRoute: () => PublicLayoutRoute,
  } as any)

const PublicLayoutPoolsPoolRoute = PublicLayoutPoolsPoolImport.update({
  id: '/pools/$pool',
  path: '/pools/$pool',
  getParentRoute: () => PublicLayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_private/_layout': {
      id: '/_private/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateLayoutImport
      parentRoute: typeof rootRoute
    }
    '/_public/_layout': {
      id: '/_public/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicLayoutImport
      parentRoute: typeof rootRoute
    }
    '/_private/_layout/sign-in': {
      id: '/_private/_layout/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PrivateLayoutSignInImport
      parentRoute: typeof PrivateLayoutImport
    }
    '/_public/_layout/login': {
      id: '/_public/_layout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLayoutLoginImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/referrals': {
      id: '/_public/_layout/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof PublicLayoutReferralsImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/tokens': {
      id: '/_public/_layout/tokens'
      path: '/tokens'
      fullPath: '/tokens'
      preLoaderRoute: typeof PublicLayoutTokensImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/': {
      id: '/_public/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicLayoutIndexImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/pools/$pool': {
      id: '/_public/_layout/pools/$pool'
      path: '/pools/$pool'
      fullPath: '/pools/$pool'
      preLoaderRoute: typeof PublicLayoutPoolsPoolImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/rebalance/$rebalance': {
      id: '/_public/_layout/rebalance/$rebalance'
      path: '/rebalance/$rebalance'
      fullPath: '/rebalance/$rebalance'
      preLoaderRoute: typeof PublicLayoutRebalanceRebalanceImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/tokens/$token': {
      id: '/_public/_layout/tokens/$token'
      path: '/$token'
      fullPath: '/tokens/$token'
      preLoaderRoute: typeof PublicLayoutTokensTokenImport
      parentRoute: typeof PublicLayoutTokensImport
    }
    '/_public/_layout/transactions/$transaction': {
      id: '/_public/_layout/transactions/$transaction'
      path: '/transactions/$transaction'
      fullPath: '/transactions/$transaction'
      preLoaderRoute: typeof PublicLayoutTransactionsTransactionImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/users/$user': {
      id: '/_public/_layout/users/$user'
      path: '/users/$user'
      fullPath: '/users/$user'
      preLoaderRoute: typeof PublicLayoutUsersUserImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/pools/': {
      id: '/_public/_layout/pools/'
      path: '/pools'
      fullPath: '/pools'
      preLoaderRoute: typeof PublicLayoutPoolsIndexImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/rebalance/': {
      id: '/_public/_layout/rebalance/'
      path: '/rebalance'
      fullPath: '/rebalance'
      preLoaderRoute: typeof PublicLayoutRebalanceIndexImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/transactions/': {
      id: '/_public/_layout/transactions/'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof PublicLayoutTransactionsIndexImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_public/_layout/users/': {
      id: '/_public/_layout/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof PublicLayoutUsersIndexImport
      parentRoute: typeof PublicLayoutImport
    }
  }
}

// Create and export the route tree

interface PrivateLayoutRouteChildren {
  PrivateLayoutSignInRoute: typeof PrivateLayoutSignInRoute
}

const PrivateLayoutRouteChildren: PrivateLayoutRouteChildren = {
  PrivateLayoutSignInRoute: PrivateLayoutSignInRoute,
}

const PrivateLayoutRouteWithChildren = PrivateLayoutRoute._addFileChildren(
  PrivateLayoutRouteChildren,
)

interface PublicLayoutTokensRouteChildren {
  PublicLayoutTokensTokenRoute: typeof PublicLayoutTokensTokenRoute
}

const PublicLayoutTokensRouteChildren: PublicLayoutTokensRouteChildren = {
  PublicLayoutTokensTokenRoute: PublicLayoutTokensTokenRoute,
}

const PublicLayoutTokensRouteWithChildren =
  PublicLayoutTokensRoute._addFileChildren(PublicLayoutTokensRouteChildren)

interface PublicLayoutRouteChildren {
  PublicLayoutLoginRoute: typeof PublicLayoutLoginRoute
  PublicLayoutReferralsRoute: typeof PublicLayoutReferralsRoute
  PublicLayoutTokensRoute: typeof PublicLayoutTokensRouteWithChildren
  PublicLayoutIndexRoute: typeof PublicLayoutIndexRoute
  PublicLayoutPoolsPoolRoute: typeof PublicLayoutPoolsPoolRoute
  PublicLayoutRebalanceRebalanceRoute: typeof PublicLayoutRebalanceRebalanceRoute
  PublicLayoutTransactionsTransactionRoute: typeof PublicLayoutTransactionsTransactionRoute
  PublicLayoutUsersUserRoute: typeof PublicLayoutUsersUserRoute
  PublicLayoutPoolsIndexRoute: typeof PublicLayoutPoolsIndexRoute
  PublicLayoutRebalanceIndexRoute: typeof PublicLayoutRebalanceIndexRoute
  PublicLayoutTransactionsIndexRoute: typeof PublicLayoutTransactionsIndexRoute
  PublicLayoutUsersIndexRoute: typeof PublicLayoutUsersIndexRoute
}

const PublicLayoutRouteChildren: PublicLayoutRouteChildren = {
  PublicLayoutLoginRoute: PublicLayoutLoginRoute,
  PublicLayoutReferralsRoute: PublicLayoutReferralsRoute,
  PublicLayoutTokensRoute: PublicLayoutTokensRouteWithChildren,
  PublicLayoutIndexRoute: PublicLayoutIndexRoute,
  PublicLayoutPoolsPoolRoute: PublicLayoutPoolsPoolRoute,
  PublicLayoutRebalanceRebalanceRoute: PublicLayoutRebalanceRebalanceRoute,
  PublicLayoutTransactionsTransactionRoute:
    PublicLayoutTransactionsTransactionRoute,
  PublicLayoutUsersUserRoute: PublicLayoutUsersUserRoute,
  PublicLayoutPoolsIndexRoute: PublicLayoutPoolsIndexRoute,
  PublicLayoutRebalanceIndexRoute: PublicLayoutRebalanceIndexRoute,
  PublicLayoutTransactionsIndexRoute: PublicLayoutTransactionsIndexRoute,
  PublicLayoutUsersIndexRoute: PublicLayoutUsersIndexRoute,
}

const PublicLayoutRouteWithChildren = PublicLayoutRoute._addFileChildren(
  PublicLayoutRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof PublicLayoutRouteWithChildren
  '/sign-in': typeof PrivateLayoutSignInRoute
  '/login': typeof PublicLayoutLoginRoute
  '/referrals': typeof PublicLayoutReferralsRoute
  '/tokens': typeof PublicLayoutTokensRouteWithChildren
  '/': typeof PublicLayoutIndexRoute
  '/pools/$pool': typeof PublicLayoutPoolsPoolRoute
  '/rebalance/$rebalance': typeof PublicLayoutRebalanceRebalanceRoute
  '/tokens/$token': typeof PublicLayoutTokensTokenRoute
  '/transactions/$transaction': typeof PublicLayoutTransactionsTransactionRoute
  '/users/$user': typeof PublicLayoutUsersUserRoute
  '/pools': typeof PublicLayoutPoolsIndexRoute
  '/rebalance': typeof PublicLayoutRebalanceIndexRoute
  '/transactions': typeof PublicLayoutTransactionsIndexRoute
  '/users': typeof PublicLayoutUsersIndexRoute
}

export interface FileRoutesByTo {
  '': typeof PrivateLayoutRouteWithChildren
  '/sign-in': typeof PrivateLayoutSignInRoute
  '/login': typeof PublicLayoutLoginRoute
  '/referrals': typeof PublicLayoutReferralsRoute
  '/tokens': typeof PublicLayoutTokensRouteWithChildren
  '/': typeof PublicLayoutIndexRoute
  '/pools/$pool': typeof PublicLayoutPoolsPoolRoute
  '/rebalance/$rebalance': typeof PublicLayoutRebalanceRebalanceRoute
  '/tokens/$token': typeof PublicLayoutTokensTokenRoute
  '/transactions/$transaction': typeof PublicLayoutTransactionsTransactionRoute
  '/users/$user': typeof PublicLayoutUsersUserRoute
  '/pools': typeof PublicLayoutPoolsIndexRoute
  '/rebalance': typeof PublicLayoutRebalanceIndexRoute
  '/transactions': typeof PublicLayoutTransactionsIndexRoute
  '/users': typeof PublicLayoutUsersIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_private/_layout': typeof PrivateLayoutRouteWithChildren
  '/_public/_layout': typeof PublicLayoutRouteWithChildren
  '/_private/_layout/sign-in': typeof PrivateLayoutSignInRoute
  '/_public/_layout/login': typeof PublicLayoutLoginRoute
  '/_public/_layout/referrals': typeof PublicLayoutReferralsRoute
  '/_public/_layout/tokens': typeof PublicLayoutTokensRouteWithChildren
  '/_public/_layout/': typeof PublicLayoutIndexRoute
  '/_public/_layout/pools/$pool': typeof PublicLayoutPoolsPoolRoute
  '/_public/_layout/rebalance/$rebalance': typeof PublicLayoutRebalanceRebalanceRoute
  '/_public/_layout/tokens/$token': typeof PublicLayoutTokensTokenRoute
  '/_public/_layout/transactions/$transaction': typeof PublicLayoutTransactionsTransactionRoute
  '/_public/_layout/users/$user': typeof PublicLayoutUsersUserRoute
  '/_public/_layout/pools/': typeof PublicLayoutPoolsIndexRoute
  '/_public/_layout/rebalance/': typeof PublicLayoutRebalanceIndexRoute
  '/_public/_layout/transactions/': typeof PublicLayoutTransactionsIndexRoute
  '/_public/_layout/users/': typeof PublicLayoutUsersIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/sign-in'
    | '/login'
    | '/referrals'
    | '/tokens'
    | '/'
    | '/pools/$pool'
    | '/rebalance/$rebalance'
    | '/tokens/$token'
    | '/transactions/$transaction'
    | '/users/$user'
    | '/pools'
    | '/rebalance'
    | '/transactions'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/sign-in'
    | '/login'
    | '/referrals'
    | '/tokens'
    | '/'
    | '/pools/$pool'
    | '/rebalance/$rebalance'
    | '/tokens/$token'
    | '/transactions/$transaction'
    | '/users/$user'
    | '/pools'
    | '/rebalance'
    | '/transactions'
    | '/users'
  id:
    | '__root__'
    | '/_private/_layout'
    | '/_public/_layout'
    | '/_private/_layout/sign-in'
    | '/_public/_layout/login'
    | '/_public/_layout/referrals'
    | '/_public/_layout/tokens'
    | '/_public/_layout/'
    | '/_public/_layout/pools/$pool'
    | '/_public/_layout/rebalance/$rebalance'
    | '/_public/_layout/tokens/$token'
    | '/_public/_layout/transactions/$transaction'
    | '/_public/_layout/users/$user'
    | '/_public/_layout/pools/'
    | '/_public/_layout/rebalance/'
    | '/_public/_layout/transactions/'
    | '/_public/_layout/users/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  PrivateLayoutRoute: typeof PrivateLayoutRouteWithChildren
  PublicLayoutRoute: typeof PublicLayoutRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  PrivateLayoutRoute: PrivateLayoutRouteWithChildren,
  PublicLayoutRoute: PublicLayoutRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_private/_layout",
        "/_public/_layout"
      ]
    },
    "/_private/_layout": {
      "filePath": "_private/_layout.tsx",
      "children": [
        "/_private/_layout/sign-in"
      ]
    },
    "/_public/_layout": {
      "filePath": "_public/_layout.tsx",
      "children": [
        "/_public/_layout/login",
        "/_public/_layout/referrals",
        "/_public/_layout/tokens",
        "/_public/_layout/",
        "/_public/_layout/pools/$pool",
        "/_public/_layout/rebalance/$rebalance",
        "/_public/_layout/transactions/$transaction",
        "/_public/_layout/users/$user",
        "/_public/_layout/pools/",
        "/_public/_layout/rebalance/",
        "/_public/_layout/transactions/",
        "/_public/_layout/users/"
      ]
    },
    "/_private/_layout/sign-in": {
      "filePath": "_private/_layout/sign-in.tsx",
      "parent": "/_private/_layout"
    },
    "/_public/_layout/login": {
      "filePath": "_public/_layout/login.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/referrals": {
      "filePath": "_public/_layout/referrals.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/tokens": {
      "filePath": "_public/_layout/tokens.tsx",
      "parent": "/_public/_layout",
      "children": [
        "/_public/_layout/tokens/$token"
      ]
    },
    "/_public/_layout/": {
      "filePath": "_public/_layout/index.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/pools/$pool": {
      "filePath": "_public/_layout/pools/$pool.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/rebalance/$rebalance": {
      "filePath": "_public/_layout/rebalance/$rebalance.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/tokens/$token": {
      "filePath": "_public/_layout/tokens/$token.tsx",
      "parent": "/_public/_layout/tokens"
    },
    "/_public/_layout/transactions/$transaction": {
      "filePath": "_public/_layout/transactions/$transaction.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/users/$user": {
      "filePath": "_public/_layout/users/$user.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/pools/": {
      "filePath": "_public/_layout/pools.index.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/rebalance/": {
      "filePath": "_public/_layout/rebalance.index.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/transactions/": {
      "filePath": "_public/_layout/transactions.index.tsx",
      "parent": "/_public/_layout"
    },
    "/_public/_layout/users/": {
      "filePath": "_public/_layout/users.index.tsx",
      "parent": "/_public/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
